export default __webpack_public_path__ + "74c8bd150d0c7b018352faa7324d4adf.svg";